import { useState } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import calendarLoading from 'assets/icons/loading-calendar.png'
import AuthUtil from 'utils/AuthUtil'
import { IFavoriteCampusServices, TCampusServiceType } from 'types/FavoritesType'
import useGetFavoriteCampusServices from './use-get-campus-services'
import Loader from 'components/ui/Loader'
import NoContent from 'components/ui/NoContent'
import FavoriteListItem from './ListItem'
import DoctorRes from './reservations/DoctorRes'
import CoiffeurRes from './reservations/CoiffeurRes'
import GymSalonRes from './reservations/GymSalonRes'
import GymTrainerRes from './reservations/GymTrainerRes'
import LactationRes from './reservations/LactationRes'
import MeetingRes from './reservations/MeetingRes'
import { ListWrapper, TabPanelWrapper } from '../styled'

export default function FavoriteCampusServices() {
  const { t } = useTranslation()
  const { list, setList, loading } = useGetFavoriteCampusServices()
  const [reservationType, setReservationType] = useState<TCampusServiceType | 0>(0)
  const [reservation, setReservation] = useState<IFavoriteCampusServices | undefined>(undefined)
  const handleSetReservation = (type: TCampusServiceType | 0, item: IFavoriteCampusServices | undefined) => () => {
    setReservationType(type)
    setReservation(item)
  }

  const renderFavoriteListItem = (favoriteItem: IFavoriteCampusServices) => (
    <FavoriteListItem
      key={favoriteItem?.id || favoriteItem?.favoriteId}
      setReservationType={handleSetReservation}
      item={favoriteItem}
      setList={setList}
    />
  )

  /* Variables */
  const employee = AuthUtil.getEmployeeSummary()
  const hasHealth = AuthUtil.hasHealth(employee?.exemptionSpecList!)
  const hasGym = AuthUtil.hasGym(employee?.exemptionSpecList!)
  const hasCoiffeur = AuthUtil.hasCoiffeur(employee?.exemptionSpecList!)
  const hasLactation = AuthUtil.hasLactation(employee?.exemptionSpecList!)
  const hasMeeting = AuthUtil.hasMeeting(employee?.exemptionSpecList!)

  if (loading) return <ListLoader />

  return (
    <TabPanelWrapper>
      {!!list?.length ? (
        <ListWrapper>
          {list?.map((li) => (
            <>
              {(li.campusServiceType === 1 && hasHealth) ||
              (li.campusServiceType === 2 && hasCoiffeur) ||
              (li.campusServiceType === 3 && hasGym) ||
              (li.campusServiceType === 4 && hasLactation) ||
              (li.campusServiceType === 6 && hasMeeting)
                ? renderFavoriteListItem(li)
                : null}
            </>
          ))}
        </ListWrapper>
      ) : (
        <NoContent message={t('homepage.favorite-campusServices-not-found')} />
      )}

      {/* Campus Services Reservation Modals */}
      {!!reservation && (
        <>
          {reservationType === 1 && (
            <DoctorRes
              id={reservation.id}
              locationId={reservation.floor.locationId}
              setReservationType={handleSetReservation}
            />
          )}
          {reservationType === 2 && (
            <CoiffeurRes
              id={reservation.id}
              locationId={reservation.floor.locationId}
              setReservationType={handleSetReservation}
            />
          )}
          {reservationType === 3 && (
            <>
              {reservation.campusServiceSubType === 1 ? (
                <GymSalonRes
                  id={reservation.id}
                  locationId={reservation.floor.locationId}
                  setReservationType={handleSetReservation}
                />
              ) : reservation.campusServiceSubType === 2 ? (
                <GymTrainerRes
                  id={reservation.id}
                  locationId={reservation.floor.locationId}
                  setReservationType={handleSetReservation}
                />
              ) : null}
            </>
          )}
          {reservationType === 4 && (
            <LactationRes
              id={reservation.id}
              locationId={reservation.floor.locationId}
              setReservationType={handleSetReservation}
            />
          )}
          {reservationType === 6 && (
            <MeetingRes
              id={reservation.id}
              locationId={reservation.floor.locationId}
              setReservationType={handleSetReservation}
            />
          )}
        </>
      )}
    </TabPanelWrapper>
  )
}

function ListLoader() {
  return (
    <div className="py-5 my-4">
      <Loader src={calendarLoading} />
    </div>
  )
}
